import { curatedText } from "@softmax/web-features/coworlds";
export function joinSentences({
  opening,
  rest,
}: {
  opening: string;
  rest: string;
}): string {
  const closed = /[.!?]$/.test(opening) ? opening : `${opening}.`;
  return rest ? `${closed} ${rest}` : closed;
}
export function aboutFrom({
  curatedBlurb,
  brief,
  opening,
  blurb,
}: {
  curatedBlurb: string | null;
  brief: {
    premise: string;
    rest: string;
  } | null;
  opening: string;
  blurb: string;
}): {
  body: string;
} | null {
  const full =
    curatedBlurb ??
    (brief && opening
      ? joinSentences({
          opening,
          rest: brief.rest,
        })
      : "");
  const body = curatedText(full);
  return body && body !== blurb ? { body } : null;
}
